import {IMaskInput} from 'react-imask'
import styles from './TextField.module.css'

/**
 * A single form control. `onChange` / `onBlur` / `onFocus` always receive an
 * event-shaped object carrying `target.name` and `target.value`, so masked and
 * unmasked fields are handled by the same page-level handlers.
 */
export function TextField(props) {
  const {
    id,
    name,
    value,
    placeholder,
    mask,
    error,
    disabled = false,
    endAdornment,
    onChange,
    onBlur,
    onFocus,
    inputProps = {},
  } = props

  const controlClassName = [
    styles.control,
    error ? styles.invalid : '',
    disabled ? styles.disabled : '',
  ].filter(Boolean).join(' ')

  const errorId = error ? `${name}-error` : undefined

  const shared = {
    id,
    name,
    className: styles.input,
    placeholder,
    disabled,
    'aria-label': placeholder,
    'aria-invalid': error ? true : undefined,
    'aria-describedby': errorId,
    onBlur,
    onFocus,
    ...inputProps,
  }

  return (
    <div className={styles.field}>
      <div className={controlClassName}>
        {mask ? (
          <IMaskInput
            {...shared}
            mask={mask}
            value={value}
            overwrite
            onAccept={(accepted) => onChange({target: {name, value: accepted}})}
          />
        ) : (
          <input
            {...shared}
            value={value}
            onChange={(e) => onChange({target: {name, value: e.target.value}})}
          />
        )}

        {endAdornment && (
          <div className={styles.adornment}>
            {endAdornment}
          </div>
        )}
      </div>

      {error && (
        <p className={styles.error} id={errorId}>
          {error}
        </p>
      )}
    </div>
  )
}

export function IconButton({label, onClick, children}) {
  return (
    <button
      type="button"
      className={styles.iconButton}
      aria-label={label}
      onClick={onClick}
      tabIndex={-1}
    >
      {children}
    </button>
  )
}

export function EyeIcon({off = false}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M1.7 10S4.9 4.6 10 4.6 18.3 10 18.3 10 15.1 15.4 10 15.4 1.7 10 1.7 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
      {off && (
        <path
          d="M3.5 3.5 16.5 16.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      )}
    </svg>
  )
}
